export function extractBusinessLookupMatches<T>(payload: unknown): T[] {
  if (!payload || typeof payload !== "object") return [];

  const response = payload as {
    matches?: unknown;
    data?: { matches?: unknown } | null;
  };
  const matches = response.data?.matches ?? response.matches;
  return Array.isArray(matches) ? (matches as T[]) : [];
}
